import {
  INDIVIDUAL_ROLE_ID,
  NCG_ROLE_ID,
  RFP_ROLE_ID,
  SECRETARIAT_ROLE_ID,
  BIRDLIFE_SECRETARIAT_ROLE_ID,
  BRC_ROLE_ID,
} from './roles'
import { getIndividualActionMenuItems } from './siteTableActionMenu/individualMenu'
import { getNcgActionMenuItems } from './siteTableActionMenu/ncgMenu'
import { getRfpAndBrcActionMenuItems } from './siteTableActionMenu/rfpBrcMenu'
import { getBirdlifeSecretariatAndKbaSecretariatActionMenuItems } from './siteTableActionMenu/secretariatMenu'

export const siteTableActionMenuItems = {
  [INDIVIDUAL_ROLE_ID]: getIndividualActionMenuItems,
  [NCG_ROLE_ID]: getNcgActionMenuItems,
  [RFP_ROLE_ID]: getRfpAndBrcActionMenuItems,
  [SECRETARIAT_ROLE_ID]: getBirdlifeSecretariatAndKbaSecretariatActionMenuItems,
  [BIRDLIFE_SECRETARIAT_ROLE_ID]: getBirdlifeSecretariatAndKbaSecretariatActionMenuItems,
  [BRC_ROLE_ID]: getRfpAndBrcActionMenuItems,
}
